"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;



















































































var _user = require("@/utils/user");


var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { list: null, tableData: [], // 列表数据
      modelDroplist: [], searchData: { userId: '', deviceTypeCode: '', markResult: '', startTime: '', endTime: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { remark: '' }, markResultList: ['好', '中', '差'], // 表格列
      tableColumns: [{ prop: 'markSource', label: '评价来源', isShow: true // 是否显示
      }, { prop: 'deviceTypeCode', label: '设备型号', isShow: true // 是否显示
      }, { prop: 'markScore', label: '评价情况', isShow: true // 是否显示
      }, { prop: 'createTime', label: '评价时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'markResult', label: '评价结果', isShow: true // 是否显示
      }] };}, mounted: function mounted() {this.searchData.userId = this.$route.params.parentId;this.init();this.getModelDroplist();}, methods: { // 获取数据
    init: function init() {var self = this;self.getData('/api/faProgramMark', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, // 每页多少条数据
    handleSizeChange: function handleSizeChange(val) {this.searchData.rows = val;this.searchData.page = 1;this.init();}, // 当前页
    handleCurrentChange: function handleCurrentChange(val) {this.searchData.page = val;this.init();}, resetFun: function resetFun() {// 重置
      this.searchData.markResult = '';this.searchData.deviceTypeCode = '';this.searchData.startTime = '';this.searchData.endTime = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();},
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/news/evaluate');
    },
    remarkFun: function remarkFun(item) {
      var self = this;
      self.addData.remark = item.remark;
      self.putData('/api/faProgramMark', {
        id: item.id,
        userId: item.userId,
        remarks: item.remarks },
      function (res) {
        self.$message({
          message: '修改成功!',
          type: 'success' });

        self.init();
      });
    },
    getModelDroplist: function getModelDroplist() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.modelDroplist = res;
      });
    } } };exports.default = _default;